<template>
  <div class="mt-n16">
    <div
      class="pa-4 text-center rounded-t-xl"
      style="background-color: #F5F5F5; height: 100%; width: 100%; opacity: 0.9;"
    >
      <v-container>
        <v-layout row wrap no-gutters>
          <v-flex md12 xs12>
            <div class="text-start headLogin">
              {{$t("loginpage.login") }} 
            </div>
          </v-flex>
          <v-flex md12 xs12>
            <div class="text-start deatailText">
              ONE Conference Anywhere Anytime
            </div>
          </v-flex>
          <v-flex md12 xs12 lg12 sm12>
            <v-form ref="form" class="text-center">
              <v-flex md12 xs12 sm12 class="mt-6">
                <!-- :placeholder= "$t('loginpage.username')" -->
                <v-text-field
                  outlined
                  dense
                  rounded
                  autofocus
                  :prefix="$t('loginpage.username')"
                  :oninput="onlyuser"
                  v-model="username"
                  @keypress="userpassword"
                  append-icon="mdi-account"
                ></v-text-field>
              </v-flex>
              <v-flex md12 xs12 sm12>
                <!-- :placeholder= "$t('loginpage.password')" -->
                <v-text-field
                  outlined
                  dense
                  :oninput="onlypass"
                  rounded
                  v-model="password"
                  @keypress="userpassword"
                  persistent-placeholder
                  :prefix="$t('loginpage.password')"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                   @click:append="show1 = !show1"
                  v-on:keyup="enterToLogInOneId"
                ></v-text-field>
              </v-flex>
              <v-flex
                md12
                lg12
                xs12
                sm12
                class="text-left"
                @click="forgotPassword"
              >
                <span
                  style="font-family: IrisUPC;
                                font-style: normal;
                                font-weight: 400;
                                font-size: 20px;
                                color: #A1A1A1;
                                line-height: 22px;
                                text-decoration: underline;"
                >
                {{$t("loginpage.forgotpassword") }}?
                </span>
              </v-flex>
              <v-layout class="text-left mt-6">
                <v-flex lg1 xs1 sm1 class="mt-n4">
                  <v-checkbox
                    color="#00BFA5"
                    value="success"
                    hide-details
                    v-model="checkbox"
                  >
                  </v-checkbox>
                </v-flex>
                <v-flex
                  lg10
                  xs10
                  sm10
                  class="text-left mt-1"
                >
                <span>
                  {{$t("loginpage.Accept") }}
                </span>
                <span class="pointer" @click="PrivacyNotice()" style="color:#2083e4;cursor: pointer;">
                  {{$t("loginpage.oneid") }}
                </span>
                <span>
                  {{$t("loginpage.and") }}
                </span>
                <span class="pointer" @click="ProtectionPolicy()" style="color:#2083e4;cursor: pointer;">
                  {{$t("loginpage.Privacy") }}
                </span>
                </v-flex>
                <v-flex lg1 xs1>
                  <span></span>
                </v-flex>
              </v-layout>
              <v-layout row wrap no-gutters justify-start>
                <v-flex lg12 md12 class="mt-6">
                  <v-btn
                    depressed
                    block
                    rounded
                    @click="loginoneid()"
                    :disabled="Disabled"
                    :loading="loadingApiLogin"
                    color="#3D85C6"
                    style="color:white;"
                  >
                  {{$t("loginpage.login") }}
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap no-gutters justify-start>
                <v-flex lg12 md12 class="mt-6">
                  <v-btn
                    depressed
                    @click="gojoinpage()"
                    block
                    rounded
                    outlined
                    color="primary"
                  >
                  <v-icon>mdi-video-plus-outline</v-icon>
                  {{$t("loginpage.joinin") }}
                  </v-btn>
                </v-flex>
              </v-layout>
              <br />
            </v-form>
          </v-flex>
          <!-- <v-flex lg4 md4 xs4 class="mt-6">
            <b><v-divider class="vDivider"/></b>
          </v-flex>
          <v-flex
            lg4
            md4
            xs4
            class="mt-7"
            style="color:#A1A1A1; font-size: 12px;"
          >
            <b>หรือ Login with</b>
          </v-flex>
          <v-flex lg4 md4 xs4 class="mt-6">
            <b><v-divider class="vDivider"/></b>
          </v-flex> -->
          <!-- <v-flex lg12 md12 xs12 class="mt-6">
                        <v-avatar color="#0B3A8F" style="color:white;" >
                            <v-icon dark>
                                mdi-email-outline
                            </v-icon>
                        </v-avatar>
                        <span class="pl-3">ONE COLLABORATION MAIL</span>
                    </v-flex> -->
          <v-flex lg12 md12 class="mt-6 pl-6">
            <span class="">{{$t("loginpage.notuser") }} ?</span>
            <span
              @click="openModelSignup"
              class="pl-3 text-decoration-underline"
              style="color: #52C41A;"
              >{{$t("loginpage.Register") }}</span
            >
          </v-flex>
          <!-- <v-flex lg12 md12 class="mt-6">
            <span class="">{{$t("loginpage.oldversion") }}</span>
            <span class="pl-1 pointer" @click="backtomeet1" style="color:#0C2FE0; text-decoration: underline;">{{$t("loginpage.click") }}</span>
          </v-flex> -->
        </v-layout>
      </v-container>
    </div>
    <!-- <Footer /> -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import CryptoJS from "crypto-js";
import Footer from "../Footer.vue";
export default {
  components: {
    // Footer
  },
  data() {
    return {
      onlyuser: "this.value = this.value.replace(/[^0-9a-zA-Z!().,`|_;:@#$%&*~+-/?]|/g, '')",
      onlypass: "this.value = this.value.replace(/[^0-9a-zA-Z!(){}''.|=`<>,^_;:@#$%&*~+-/?]|/g, '')",
      username: "",
      show1: false,
      password: "",
      Disabled: true,
      loadingApiLogin: false,
      jwt: require('jsonwebtoken'),
      checkbox: false,
      sharetoken: '',
      usertoken: '',
    };
  },
  watch: {
    checkbox(value) {
      if (value) {
        this.conditionDialbleBtnLogin();
      } else {
        this.Disabled = true;
      }
    }
  },
  created() {
    this.uuid = this.$route.query.uuid
    this.sharetoken = this.$route.query.sharetoken
    if(this.sharetoken === '' || this.sharetoken === undefined || this.sharetoken === null){
      if (localStorage.getItem("user-token") === null) {
      // console.log('user-token')
    } else {
      // this.checkrole()
      // this.goPage("/activate");
      this.goPage("/manage");
    }
    } else {
      this.sharetokenoneplatform()
    }

    // console.log('uuid', this.uuid)
    this.$multiwatch(["username", "password"], function() {
      const valid = this.$refs.form.validate();
      if (this.checkbox === true) {
        this.Disabled = !valid;
      }
    });
  },
  computed: {
    ...mapState("dialog", ["switchSigninSignup"])
  },
  methods: {
    ...mapActions("dialog", ["setSwitchSignSignup"]),
    openModelSignup() {
      this.setSwitchSignSignup(true);
    },
    openModalTermOfUser() {
      window.open(process.env.VUE_APP_ONEID + "/api/term-of-use", "_blank");
    },
    forgotPassword() {
      window.open(
        process.env.VUE_APP_ONEID + "/type_forgot_password",
        "_blank"
      );
    },
    PrivacyNotice() {
      window.open(
        process.env.VUE_APP_POLICIES + '?' + 'tabs=' + 0,
        "_blank"
      );
    },
    ProtectionPolicy() {
      window.open(
        process.env.VUE_APP_POLICIES + '?' + 'tabs=' + 1,
        "_blank"
      );
    },
    backtomeet1() {
      window.open('https://meet1.one.th', '_blank')
    },
    gojoinpage() {
       this.$router.push({ path: '/joinpage' }).catch(() => {})
    },
    userpassword(e) {
      // only english and number
      const key = e.which ? e.which : e.keyCode
      if (key >= 33 && key <= 64) {
        return true
      } // number
      if (key >= 65 && key <= 90) {
        return true
      } // A-Z
      if (key >= 91 && key <= 125) {
        return true
      } // a-z
      return e.preventDefault()
    },
    sharetokenoneplatform () {
      this.axios.post(process.env.VUE_APP_API + "/api/v1/auth/sharetoken", {
          sharetoken: this.sharetoken
          }).then(res => {
            // console.log('res', res.data.data)
            localStorage.setItem("user-token", res.data.data.token);
            localStorage.setItem("access-token", res.data.data.oneid.access_token);
           localStorage.setItem( "refresh_token",  res.data.data.oneid.refresh_token );
          this.decodejwttoken(res.data.data.token)
          }).catch(err => {
            console.log('err', err)
          })
    },
    encodeJS(data) {
      // console.log(data)
    try {
      var ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        process.env.VUE_APP_SECRET_KEY
      ).toString();
      this.usertoken = ciphertext
      return ciphertext;
    } catch (error) {
      console.log(error);
      return error;
    }
    },
    loginoneid() {
      if (this.username === "" && this.password === "") {
        this.$swal('Please, enter "Username" and "Password"', "", "warning");
      } else if (this.username !== "" && this.password === "") {
        this.$swal('Please, enter "Password"', "", "warning");
      } else if (this.username === "" && this.password !== "") {
        this.$swal('Please, enter "Username"', "", "warning");
      } else {
        this.loadingApiLogin = true;
        this.Disabled = true;
        this.encodeJS(JSON.stringify({ username: this.username, password: this.password}))
        this.axios
          .post(process.env.VUE_APP_API + "/api/lv1/auth/login", {
            token : this.usertoken
            // username: 'warinprd2',
            // password: 'warin-Prd2'
            // username: this.username,
            // password: this.password
          })
          .then(res => {
            if (res.data.code === 200) {
              // console.log('200', res.data)
              // console.log('200', res)
              if (res.data.result === "Success") {
                this.loadingApiLogin = false;
                this.Disabled = false;
                localStorage.setItem("user-token", res.data.data.token);
                localStorage.setItem("oneid-token", res.data.data.oneid);
                this.decodejwttoken(res.data.data.token)
                // localStorage.setItem(
                //   "access-token",
                //   res.data.data.oneid.access_token
                // );
                // localStorage.setItem( "refresh_token",  res.data.data.oneid.refresh_token );
                // this.checkrole()
                // this.goPage("/activate");
                if (this.$route.query.uuid === undefined) {
                    this.goPage("/manage");
                  } else {
                    this.goPage('/join/?uuid=' + this.uuid )
                  }
                // console.log('Success', res.data)
                this.$swal(res.data.message, "", "success");
              } else {
                this.loadingApiLogin = false;
                this.Disabled = false;
                this.$swal(res.data.message, "", "warning");
                // console.log('warning', res.data)
              }
            } else {
              this.$swal(res.data.message, "", "warning");
              this.loadingApiLogin = false;
              this.Disabled = false;
            }
          })
          .catch(e => {
            this.$swal("Cannot read properties of undefined", "", "warning");
            console.log("400", e);
            this.loadingApiLogin = false;
            this.Disabled = false;
          });
        //   console.log('env', process.env.VUE_APP_API)
        //   console.log('username', this.username)
        //   console.log('password', this.password)
      }
    },
    decodejwttoken(data) {
      var token = data
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, '')
      var data = this.jwt.decode(decryptedText)
      // var userData = data
      // console.log('this.userData', data.user._id)
      this.createthem(data.user._id)
    },
    goPage(link) {
      this.$router.push(link).catch(() => {});
    },
    conditionDialbleBtnLogin() {
      const valid = this.$refs.form.validate();
      if (valid === true) {
        this.Disabled = false;
      } else {
        this.Disabled = true;
      }
    },
    createthem(userid) {
                // this.checkrole()
      if (this.$route.query.uuid === undefined) {
                    // this.goPage("/activate");
        this.goPage("/manage");
      } else {
        this.goPage('/join/?uuid=' + this.uuid )
      }
      // this.axios
      //     .post(process.env.VUE_APP_API + "/api/v1/theme/create/", {
      //       user_id: userid
      // }).then(res => {
      //   // console.log('createidprofile', res)
      // }).catch(err => {
      //   console.log('createidprofile', err.message)
      // })
    },
    enterToLogInOneId: function(e) {
      if (e.keyCode === 13) {
        if (this.Disabled === true) {
          this.$swal(this.$t("loginpage.Accept") ,this.$t("loginpage.oneid"),"warning");
        } else {
          this.loginoneid();
        }
      }
    }
  }
};
</script>
<style scoped>
.headLogin {
  font-family: Ebrima;
  font-style: normal;
  font-weight: 700;
  font-size: 38px;
  line-height: 48px;
  color: #0b3a8f;
}
.deatailText {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #a1a1a1;
  line-height: 22px;
}
</style>
